import {Component, input, output, ChangeDetectionStrategy} from '@angular/core';
import {User} from "../../../../models/user";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {Facility} from "../../../../models/facility";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-banner',
  imports: [
    NgOptimizedImage,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './banner.component.css'
})
export class BannerComponent {
  screenSize = input.required<'desktop' | 'tablet' | 'mobile'>();
  user = input.required<User | null>();
  activeFacility = input.required<Facility | null>();

  chooseFacility = output();
  logout = output();
}
